const UNSUPPORTED_ADA_BOT_PATHS = [
  '/ads/ads-credit',
  '/ads/ads-credit/top-up',
  '/ads/top-up-success',
  '/ads/top-up-pending',
  '/ads/top-up-failed',
]

class ChatBotService {
  constructor(strategy) {
    this.strategy = strategy
  }

  initChatBot({ language }) {
    this.strategy.initChatBot({ language })
  }

  changeChatBotLanguage(language) {
    this.strategy.changeChatBotLanguage(language)
  }

  toggleChatBotIfNeeded = (routeTo) => {
    const path = routeTo.path
    const shouldHideAdaBot = UNSUPPORTED_ADA_BOT_PATHS.includes(path)

    if (shouldHideAdaBot) {
      return this.strategy.hideChatbot()
    }

    return this.strategy.showChatbot()
  }

  setChatMetaFields(metaFields) {
    this.strategy.setChatMetaFields(metaFields)
  }

  openChatbot() {
    return this.strategy.openChatbot()
  }
}

export default ChatBotService
